import { CardStatus } from '@caslink/common-client/ng-app/alerts/typings/CardStatus';
import * as moment from 'moment';
import { DateFormatPipe, UtcPipe } from 'ngx-moment';
import { ControlService } from '../../control/control.service';
import { DataFormatService } from '../services/data-format.service';
import { IControlModel, IControlSubRoutes, IDeviceModel, IDisplayInfo } from './models';
import { DeviceModelInitializationOptions } from '../../device-model/device-model-initialization-options.interface';
import { DeviceModelService } from '../services/device-model.service';

/**
 * An empty example model that other IDeviceModels can inherit from to provide default methods,
 * as well as throwing a user-friendly error if EntityModelFactory is used incorrectly.
 * This file must keep its _ prefix so it is loaded before the classes that inherit from it.
 */

export class NullDeviceModel implements IDeviceModel {
    public eventless: boolean = false;

    constructor(
        protected controlService: ControlService = null,
        protected deviceModelService: DeviceModelService = null,
        protected dateFormatPipe: DateFormatPipe = null,
        protected utcPipe: UtcPipe = null
    ) {
    }

    public controls: IControlModel[];
    public descriptor: string = '';

    public modelName: string = '';
    public subroutes: IControlSubRoutes;

    protected areaId: number;
    protected locationId: number;

    public initialize(options: DeviceModelInitializationOptions) {
        this.areaId = options.areaId;
        this.locationId = options.locationId;
        this.descriptor = options.descriptor;
        this.modelName = options.modelName;
        this.subroutes = options.subroutes;
        this.setupCards(options.controls);
    }

    public formatDate(date: Date) {
        if (!this.utcPipe || !this.dateFormatPipe) {
            return date.toString();
        }
        const aMoment = moment(date);
        const utc = this.utcPipe.transform(aMoment);
        const formatted = this.dateFormatPipe.transform(utc, DataFormatService.value);

        return `${formatted} (UTC)`;
    }

    public setup(control: IControlModel): void { /* override this */ }

    public setupCards(data: IControlModel[]): void {
        this.controls = data;

        this.controls.forEach((control) => {
            control.displayInfo = control.displayInfo || {
                dataViewModel: [],
                isCardEditable: false
            } as IDisplayInfo;
            this.setup(control);
        });
    }

    public updateCard(control: IControlModel, viewModel: CASLink.Device.Ui.ViewModel.DynamicControls.ControlSummaryViewModel): void {
        /* override this */
    }

    public updateStatus(control: IControlModel, status: CardStatus): void {
        control.status = this.deviceModelService.getStatus(status);
    }
}
